import { combineReducers } from "redux";
import clients from "./clients";
import feeds from "./feeds";
import feedOwnerReport from "./feedOwnerReport";
import feedOwnerReportDetail from "./feedOwnerReportDetail";
import reportConfigs from "./reportConfigs";
import progress from "./progress";
import vrReportsOngoing from "./vrReportsOngoing";

export const reducers = {
  clients,
  feeds,
  feedOwnerReport,
  feedOwnerReportDetail,
  progress,
  reportConfigs,
  vrReportsOngoing
};

export default combineReducers(reducers);
